import React, { Fragment } from 'react';


import MoonLight from './MoonLight';
import CartHeader from './CartHeader';

import UserHeader from './UserHeader';
import { UL } from '../../../AbstractElements';
import { Col } from 'reactstrap';

const RightHeader = () => {


//check if it's a public servant
//retrieve roles
//check

  return (
    <Fragment>
      <Col  className='nav-right pull-right right-header ms-auto' style={{margin:0,paddingBottom:0}}>
        {/* <Col md="8"> */}
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }} style={{margin:0,paddingBottom:0}}>         
          
          <MoonLight />
		  {/*<CartHeader />   */ }      
          <UserHeader />
        </UL>
        {/* </Col> */}
      </Col>
    </Fragment>
  );
};

export default RightHeader;
